'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _recompose = require('recompose');

var _Field = require('./Field');

var _Field2 = _interopRequireDefault(_Field);

var _forms = require('./forms');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function mapStateToProps(state, props) {
  var formErrors = _forms.selectors.formErrors(state.forms, { form: props.form });
  var fieldsValid = _forms.selectors.isAllFieldsHaveStatus(state.forms, R.assoc('status', 'valid', props));

  return {
    fields: _forms.selectors.fields(state.forms, props),
    valid: fieldsValid && R.isEmpty(formErrors),
    errors: formErrors
  };
}

var connectOptions = { areStatePropsEqual: R.equals };

exports.default = function (Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _recompose.compose)((0, _recompose.withProps)(R.pipe(R.unless(R.has('name'), R.assoc('name', options.name)), R.assoc('Field', _Field2.default))), (0, _recompose.withContext)({ form: _propTypes2.default.string.isRequired }, function (props) {
    return {
      form: props.name
    };
  }), (0, _recompose.renameProp)('name', 'form'), (0, _reactRedux.connect)(mapStateToProps, null, null, connectOptions), (0, _recompose.branch)(function () {
    return typeof options.validator === 'function';
  }, (0, _recompose.lifecycle)({
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      if (!R.equals(this.props.fields, nextProps.fields)) {
        var action = options.validator(this.props.form, R.pluck('value', nextProps.fields));
        if (action) {
          this.props.dispatch(action);
        } else {
          this.props.dispatch(_forms.actions.validateForm(this.props.form, { status: true }));
        }
      }
    }
  })))(Component);
};